import ujs from '@rails/ujs';
import jQuery from 'jquery';

ujs.start();

if (window !== undefined) {
  window.$ = jQuery;
  window.jQuery = jQuery;
}
